<template>
<div >
  <div class="form-group">
    <label for="brand"><strong>MARCHIO</strong></label>
      <select id="brand" :disabled="items.length==0" @change="$emit('update',brandId,$event)" class="form-control" v-model="brandId" >
        <option v-if="props.allBrands" :value="'%'">TUTTI</option> 
        <option v-for="(item,index) in items" :value="item.brand" :key="index">{{item.brand}} </option>        
      </select>  
  </div>  
</div>

</template>
<script>
import api             from "@/api";

export default {
  props : ['props'] , 
  components: {},
  data() {
    return {
     
      brandId                : '%',
      items                  : [],
      spinner                : false
     
    };
  },
   
  mounted: function() {
    

  },
  created: function() {

      //console.log('Props',this.props)
      if(this.props.supplierId)
      {
        this.getData()
       
      }
  },
  methods: 
  {
    async getData()
    {
      this.items = []      
      var sp   = {'sp'         : 'spSupplierBrandList'}      
      var data = {'supplierId' : this.props.supplierId}
      var json  = Object.assign(data, sp)
      
      await api.post(json).then(res => {
                   
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]   
              if(this.props.Id)
              {
                this.brandId = this.props.Id
              }
              
              
            }
           else if(res.status==500)
           {
                console.log(res.data)
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });
    
 



     
    },
  
    
    
  
}

}
</script>
<style scoped>

</style>